import React, { useState, useEffect } from 'react';

/**
 * Self-contained countdown display so its 1-second updates don't re-render the parent.
 * Used for the "first 7 days unlimited" / FREE plan countdown in the header.
 */
const CountdownDisplay = ({ unlimitedPeriodEndAt, hasPaid, hasAccess, first7DaysUnlimited, isDark }) => {
  const [display, setDisplay] = useState(null);

  useEffect(() => {
    if (!unlimitedPeriodEndAt) {
      const isFree = !(hasPaid || hasAccess);
      setDisplay(isFree ? '00:00:00' : null);
      return;
    }
    const format = () => {
      const now = Date.now();
      const end = new Date(unlimitedPeriodEndAt).getTime();
      let ms = Math.max(0, end - now);
      if (ms <= 0) {
        setDisplay('00:00:00');
        return;
      }
      const sec = Math.floor(ms / 1000) % 60;
      const min = Math.floor(ms / 60000) % 60;
      const hours = Math.floor(ms / 3600000) % 24;
      const days = Math.floor(ms / 86400000);
      const pad = n => String(n).padStart(2, '0');
      setDisplay(days > 0 ? `${pad(days)}:${pad(hours)}:${pad(min)}:${pad(sec)}` : `${pad(hours)}:${pad(min)}:${pad(sec)}`);
    };
    format();
    const t = setInterval(format, 1000);
    return () => clearInterval(t);
  }, [unlimitedPeriodEndAt, hasPaid, hasAccess]);

  if (display == null) return null;
  if (hasPaid || hasAccess) return null;

  if (first7DaysUnlimited) {
    return (
      <span className={`text-xs font-mono ${isDark ? 'text-cyan-300' : 'text-cyan-700'}`}>{display}</span>
    );
  }
  return (
    <span className={`text-xs font-mono ${isDark ? 'text-zinc-500' : 'text-gray-500'}`}>{display}</span>
  );
};

export default CountdownDisplay;
